/* ==========================================================================
   DopaDrop — JS global du thème
   Reprend les comportements du site source (count-up, barres de progression,
   titre "morph" du hero, mini-nav sticky, menu mobile) + logique boutique
   (sélecteur de variantes, quantité, panier AJAX).
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     1. Compteurs animés  [data-countup]
     ------------------------------------------------------------------ */
  function initCountUp() {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.textContent = el.dataset.countup + (el.dataset.suffix || '');
      });
      return;
    }

    els.forEach(function (el) {
      el.textContent = '0' + (el.dataset.suffix || '');
      el.style.opacity = '0';
      el.style.transform = 'translateY(14px)';
      el.style.transition = 'opacity .6s ease, transform .6s ease';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);

        var target = parseFloat(el.dataset.countup);
        var suffix = el.dataset.suffix || '';
        var decimals = parseInt(el.dataset.decimals || '0', 10);

        requestAnimationFrame(function () {
          el.style.opacity = '1';
          el.style.transform = 'none';
        });

        var duration = 1600;
        var start = performance.now();
        var step = function (now) {
          var p = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent =
            (decimals > 0 ? (target * eased).toFixed(decimals) : Math.round(target * eased)) +
            suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.35 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------
     2. Barres de progression  [data-barfill]
     ------------------------------------------------------------------ */
  function initBars() {
    var bars = document.querySelectorAll('[data-barfill]');
    if (!bars.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      bars.forEach(function (el) { el.style.width = el.dataset.barfill + '%'; });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var pct = entry.target.dataset.barfill;
        requestAnimationFrame(function () { entry.target.style.width = pct + '%'; });
      });
    }, { threshold: 0.4 });

    bars.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------
     3. Titre "morph" du hero  [data-dd-morph]
        data-morph-words : JSON [["Le porno","est virtuel"], ...]
     ------------------------------------------------------------------ */
  function initHeroMorph() {
    document.querySelectorAll('[data-dd-morph]').forEach(function (wrap) {
      var combos;
      try {
        combos = JSON.parse(wrap.dataset.morphWords || '[]');
      } catch (e) {
        combos = [];
      }
      var layers = wrap.querySelectorAll('.dd-morph__layer');
      if (!combos.length || layers.length < 2) return;

      var html = function (combo) {
        var span = document.createElement('span');
        span.className = 'dd-morph__accent';
        span.textContent = combo[0];
        return span.outerHTML + ' ' + combo[1];
      };

      layers[0].innerHTML = html(combos[0]);
      layers[0].style.opacity = '1';
      if (combos.length < 2 || reduceMotion) return;

      var idx = 0;
      var active = 0;
      setInterval(function () {
        idx = (idx + 1) % combos.length;
        var next = active === 0 ? 1 : 0;
        layers[next].innerHTML = html(combos[idx]);
        layers[next].style.opacity = '1';
        layers[active].style.opacity = '0';
        active = next;
      }, 3100);
    });
  }

  /* ------------------------------------------------------------------
     4. Mini-nav sticky (page Comprendre)  [data-dd-mininav]
     ------------------------------------------------------------------ */
  function initMiniNav() {
    var nav = document.querySelector('[data-dd-mininav]');
    if (!nav) return;
    var threshold = parseInt(nav.dataset.showAfter || '500', 10);
    var links = nav.querySelectorAll('a[href^="#"]');

    var onScroll = function () {
      nav.dataset.visible = window.scrollY > threshold ? 'true' : 'false';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if ('IntersectionObserver' in window && links.length) {
      var map = {};
      links.forEach(function (a) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) map[id] = a;
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var link = map[entry.target.id];
          if (!link) return;
          if (entry.isIntersecting) {
            links.forEach(function (a) { a.removeAttribute('aria-current'); });
            link.setAttribute('aria-current', 'true');
          }
        });
      }, { rootMargin: '-30% 0px -55% 0px' });
      Object.keys(map).forEach(function (id) {
        io.observe(document.getElementById(id));
      });
    }
  }

  /* ------------------------------------------------------------------
     5. Menu mobile
     ------------------------------------------------------------------ */
  function initMobileNav() {
    var burger = document.querySelector('[data-dd-burger]');
    var panel = document.querySelector('[data-dd-mobile-nav]');
    if (!burger || !panel) return;

    burger.addEventListener('click', function () {
      var open = panel.dataset.open === 'true';
      panel.dataset.open = open ? 'false' : 'true';
      burger.setAttribute('aria-expanded', open ? 'false' : 'true');
    });

    document.addEventListener('click', function (e) {
      if (panel.dataset.open !== 'true') return;
      if (panel.contains(e.target) || burger.contains(e.target)) return;
      panel.dataset.open = 'false';
      burger.setAttribute('aria-expanded', 'false');
    });
  }

  /* ------------------------------------------------------------------
     6. Onglets accessibles  [data-dd-tabs]
     ------------------------------------------------------------------ */
  function initTabs() {
    document.querySelectorAll('[data-dd-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            if (p.id === tab.getAttribute('aria-controls')) {
              p.removeAttribute('hidden');
            } else {
              p.setAttribute('hidden', '');
            }
          });
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     7. Sélecteur de quantité  [data-dd-quantity]
     ------------------------------------------------------------------ */
  function initQuantity(scope) {
    (scope || document).querySelectorAll('[data-dd-quantity]').forEach(function (box) {
      if (box.dataset.ddBound) return;
      box.dataset.ddBound = 'true';
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var value = parseInt(input.value, 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          if (btn.dataset.action === 'increase') {
            value += 1;
          } else {
            value = Math.max(min, value - 1);
          }
          input.value = value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     8. Sélecteur de variantes produit  [data-dd-product]
        Le <script type="application/json" data-dd-variants> contient
        les variantes sérialisées côté Liquid.
     ------------------------------------------------------------------ */
  function initProductForms() {
    document.querySelectorAll('[data-dd-product]').forEach(function (root) {
      var jsonEl = root.querySelector('[data-dd-variants]');
      if (!jsonEl) return;

      var variants;
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      var idInput = root.querySelector('[data-dd-variant-id]');
      var priceEl = root.querySelector('[data-dd-price]');
      var comparePriceEl = root.querySelector('[data-dd-compare-price]');
      var saleBadge = root.querySelector('[data-dd-sale-badge]');
      var soldoutBadge = root.querySelector('[data-dd-soldout-badge]');
      var addBtn = root.querySelector('[data-dd-add-to-cart]');
      var addBtnText = addBtn ? addBtn.querySelector('[data-dd-add-label]') : null;
      var moneyFormat = root.dataset.moneyFormat || '{{amount}}';
      var labels = {
        add: root.dataset.labelAdd || 'Add to cart',
        soldout: root.dataset.labelSoldout || 'Sold out',
        unavailable: root.dataset.labelUnavailable || 'Unavailable'
      };

      function formatMoney(cents) {
        var value = (cents / 100).toFixed(2);
        if (/\{\{\s*amount_no_decimals\s*\}\}/.test(moneyFormat)) {
          value = String(Math.round(cents / 100));
        } else if (/\{\{\s*amount_with_comma_separator\s*\}\}/.test(moneyFormat)) {
          value = value.replace('.', ',');
        }
        return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
      }

      function selectedOptions() {
        var opts = [];
        root.querySelectorAll('[data-dd-option]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          var select = group.querySelector('select');
          if (checked) opts.push(checked.value);
          else if (select) opts.push(select.value);
        });
        return opts;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function updateUI(variant) {
        if (!variant) {
          if (addBtn) {
            addBtn.disabled = true;
            if (addBtnText) addBtnText.textContent = labels.unavailable;
          }
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (comparePriceEl) {
          comparePriceEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
          comparePriceEl.hidden = !onSale;
        }
        if (saleBadge) saleBadge.hidden = !onSale;
        if (priceEl) priceEl.classList.toggle('dd-price--sale', Boolean(onSale));

        if (soldoutBadge) soldoutBadge.hidden = variant.available;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          if (addBtnText) {
            addBtnText.textContent = variant.available ? labels.add : labels.soldout;
          }
        }

        if (variant.featured_media_id) {
          var thumb = root.querySelector(
            '[data-dd-thumb][data-media-id="' + variant.featured_media_id + '"]'
          );
          if (thumb) thumb.click();
        }

        if (window.history && window.history.replaceState && root.dataset.updateUrl === 'true') {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      root.querySelectorAll('[data-dd-option] input, [data-dd-option] select').forEach(function (el) {
        el.addEventListener('change', function () {
          updateUI(findVariant(selectedOptions()));
        });
      });

      /* Galerie : miniatures */
      var mainImg = root.querySelector('[data-dd-main-image]');
      root.querySelectorAll('[data-dd-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!mainImg) return;
          mainImg.src = thumb.dataset.src;
          if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
          if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;
          root.querySelectorAll('[data-dd-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     9. Panier : mise à jour des quantités / suppression de ligne
        Utilise routes.cart_change_url exposé par le layout.
     ------------------------------------------------------------------ */
  function initCart() {
    var cart = document.querySelector('[data-dd-cart]');
    if (!cart) return;
    var routes = window.ddRoutes || {};
    var changeUrl = routes.cartChangeUrl || '/cart/change';

    function reload() {
      window.location.reload();
    }

    function changeLine(line, quantity) {
      cart.setAttribute('aria-busy', 'true');
      fetch(changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          return r.json();
        })
        .then(reload)
        .catch(reload);
    }

    cart.querySelectorAll('[data-dd-line-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(parseInt(btn.dataset.line, 10), 0);
      });
    });

    cart.querySelectorAll('[data-dd-line-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        changeLine(parseInt(input.dataset.line, 10), qty);
      });
    });
  }

  /* ------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     Sélecteur de langue (header) : soumet le formulaire de localisation
     natif dès que la langue change.
     ------------------------------------------------------------------ */
  function initLanguageSelectors() {
    document.querySelectorAll('[data-dd-lang-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  function init() {
    initCountUp();
    initBars();
    initHeroMorph();
    initMiniNav();
    initMobileNav();
    initTabs();
    initQuantity(document);
    initProductForms();
    initCart();
    initLanguageSelectors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
